import { render, staticRenderFns } from "./comp_FooterContactList.vue?vue&type=template&id=779d571c&scoped=true&"
import script from "./comp_FooterContactList.vue?vue&type=script&lang=js&"
export * from "./comp_FooterContactList.vue?vue&type=script&lang=js&"
import style0 from "./comp_FooterContactList.vue?vue&type=style&index=0&id=779d571c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d571c",
  null
  
)

export default component.exports